// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import { useState } from 'react';
import axios from 'axios';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from 'sonner';
import { FolderPlus } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CreateFolderModal({ open, onOpenChange, onSuccess, category, parentId }) {
  const [folderName, setFolderName] = useState('');
  const [creating, setCreating] = useState(false);

  const handleCreate = async (e) => {
    e.preventDefault();
    
    if (!folderName.trim()) {
      toast.error('Digite um nome para a pasta');
      return;
    }

    setCreating(true);
    
    try {
      await axios.post(`${API}/folders`, {
        name: folderName.trim(),
        category: category,
        parent_id: parentId
      });
      
      toast.success('Pasta criada com sucesso!');
      setFolderName('');
      onOpenChange(false);
      onSuccess?.();
    } catch (error) {
      const message = error.response?.data?.detail || 'Erro ao criar pasta';
      toast.error(message);
    } finally {
      setCreating(false);
    }
  };

  const resetModal = () => {
    setFolderName('');
  };

  return (
    <Dialog open={open} onOpenChange={(newOpen) => {
      if (!newOpen) resetModal();
      onOpenChange(newOpen);
    }}>
      <DialogContent className="sm:max-w-md" data-testid="create-folder-modal">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'Manrope, sans-serif' }}>
            Nova Pasta
          </DialogTitle>
          <DialogDescription>
            Crie uma nova pasta para organizar seus documentos.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleCreate} className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="folder-name">Nome da pasta</Label>
            <Input
              id="folder-name"
              data-testid="folder-name-input"
              placeholder="Ex: Janeiro 2024"
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
              autoFocus
            />
          </div>

          <div className="flex justify-end gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              disabled={creating}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              disabled={!folderName.trim() || creating}
              className="bg-slate-900 hover:bg-slate-800"
              data-testid="create-folder-submit"
            >
              {creating ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2" />
                  Criando...
                </>
              ) : (
                <>
                  <FolderPlus className="w-4 h-4 mr-2" />
                  Criar Pasta
                </>
              )}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
